import script from "./HomePageView.vue?vue&type=script&setup=true&lang=js"
export * from "./HomePageView.vue?vue&type=script&setup=true&lang=js"

import "./HomePageView.vue?vue&type=style&index=0&id=278f9e99&lang=scss"

const __exports__ = script;

export default __exports__